import { atom } from 'jotai'

export const hideHeaderAtom = atom<boolean>(false)
